import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Box } from '@mui/material';
import Header from './components/Header';
import Main from './components/main';
import Contacts from './components/Contacts';
import NotFound from './components/NotFound';

import AllVariantsPage from './components/AllVariantsPage';
import AllPurchasesPage from './components/AllPurchasesPage';
import { ColorModeProvider } from './ThemeContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/Login';

function AppContent(): React.JSX.Element {
  const { user } = useAuth();

  if (!user) {
    return <Login />;
  }

  return (
    <Router>
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header />
        <Box component="main" sx={{ flexGrow: 1 }}>
          <Routes>
            <Route path="/" element={<Main />} />
            <Route path="/contacts" element={<Contacts />} />
            <Route path="/all-variants" element={<AllVariantsPage />} />
            <Route path="/all-purchases" element={<AllPurchasesPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Box>
      </Box>
    </Router>
  );
}

function App(): React.JSX.Element {
  return (
    <ColorModeProvider>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </ColorModeProvider>
  );
}

export default App; 